import { SET_INFO, SET_REQUISITION_IS_AGREED } from "./constants";

export const setRequisitionIsAgreedAction = (payload) => ({ type: SET_REQUISITION_IS_AGREED, payload });
export const setRequisitionInfoAction = (payload) => ({ type: SET_INFO, payload });